// pages/NewCategoryPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { alertSuccess, alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { categoryService, uploadService } from "@cabukaka/services";
import CategoryForm from "../../../components/features/categories/CategoryForm";
import { useToken, useSectors } from "@cabukaka/hooks";
import { PageProps } from "../../../types/props/Props";

export default function NewCategoryPage({ }: PageProps) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { token } = useToken();
    const { sectors } = useSectors();

    const generateSlug = (name: string) => {
        return name
            .toLowerCase()
            .trim()
            .replace(/[éèêë]/g, 'e')
            .replace(/[àâä]/g, 'a')
            .replace(/[îï]/g, 'i')
            .replace(/[ôö]/g, 'o')
            .replace(/[ùûü]/g, 'u')
            .replace(/[ç]/g, 'c')
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '')
            .replace(/-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '');
    };

    const handleSubmit = async (data: { name: string; sectorId: string; imageFile?: File; existingImage?: string }) => {
        setIsLoading(true);
        if (!token) {
            alertError("Veillez vous connecter ")
            return
        }
        try {
            let imageUrl = data.existingImage || '';

            if (data.imageFile) {
                imageUrl = await uploadService.upload(data.imageFile, token!);
            }

            const slug = generateSlug(data.name);

            await categoryService.baseService.create({
                name: data.name,
                slug,
                sectorId: data.sectorId,
                image: imageUrl
            }, token);

            alertSuccess("Catégorie créée avec succès");
            navigate(-1);
        } catch (error: any) {
            alertServerError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <PageLayout title="Nouvelle catégorie">
            <PageContainer>
                <CategoryForm
                    sectors={sectors}
                    onSubmit={handleSubmit}
                    isSubmitting={isLoading}
                />
            </PageContainer>
        </PageLayout>
    );
}